// ============================================================================
// HOOPS FOR THOUGHT: DRAFT PICK INVENTORY & TRADE RESTRICTIONS
// 2026-2032 All Rounds — Source: Fanspo, Hoops Rumors, ESPN Bobby Marks
// ============================================================================
const DRAFT_PICKS = {
ATL: { picks: [
  { year: 2026, round: 1, status: 'own', note: 'SAS swap rights; UTA/MIN/CLE swap pool' },
  { year: 2026, round: 1, status: 'incoming', from: 'MIL/NOP', note: 'Most favorable of MIL and NOP 1sts' },
  { year: 2026, round: 2, status: 'incoming', from: 'BOS/IND/MIA', note: 'Less favorable of BOS 2nd and best of IND/MIA' },
  { year: 2026, round: 2, status: 'traded', to: 'BKN' },
  { year: 2027, round: 1, status: 'traded', to: 'SAS' },
  { year: 2027, round: 1, status: 'incoming', from: 'NOP/MIL', note: 'Less favorable, protected 1-4' },
  { year: 2027, round: 2, status: 'own' },
  { year: 2028, round: 1, status: 'own', note: 'UTA/CLE swap rights' },
  { year: 2028, round: 2, status: 'traded', to: 'BKN' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 2, status: 'incoming', from: 'CLE' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'own' },
  { year: 2030, round: 2, status: 'incoming', from: 'NYK' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own', note: 'HOU swap rights (prot 56-60)' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], stepien: true, tradeExceptions: [{ amount: 13100000, expires: '2026-07', from: "De'Andre Hunter trade" }] },

BOS: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 2, status: 'own', note: 'ATL swap rights in multi-team scenario' },
  { year: 2026, round: 2, status: 'incoming', from: 'ORL/DET/MIL' },
  { year: 2026, round: 2, status: 'incoming', from: 'MIN/NYK/NOP/POR' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2028, round: 1, status: 'own', note: 'SAS swap rights (prot #1 only)' },
  { year: 2029, round: 1, status: 'traded', to: 'POR/WAS' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own' },
  { year: 2031, round: 2, status: 'incoming', from: 'HOU', note: 'Protected 31-55' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [{ amount: 22500000, expires: '2026-07', from: 'Jrue Holiday trade' }] },

BKN: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 2, status: 'own', note: 'LAC/BOS/IND/MIA swap rights' },
  { year: 2026, round: 2, status: 'traded', to: 'MIA', note: 'Protected 31-55' },
  { year: 2026, round: 2, status: 'incoming', from: 'ATL' },
  { year: 2027, round: 1, status: 'own', note: 'HOU swap rights' },
  { year: 2027, round: 1, status: 'incoming', from: 'NYK' },
  { year: 2027, round: 2, status: 'incoming', from: 'LAL' },
  { year: 2028, round: 1, status: 'own', note: 'PHI/PHX/NYK swap rights' },
  { year: 2028, round: 1, status: 'incoming', from: 'PHI', note: 'Protected 1-8' },
  { year: 2028, round: 2, status: 'own' },
  { year: 2028, round: 2, status: 'incoming', from: 'ATL' },
  { year: 2028, round: 2, status: 'incoming', from: 'MEM' },
  { year: 2029, round: 1, status: 'incoming', from: 'NYK' },
  { year: 2029, round: 1, status: 'own', note: 'HOU/DAL/PHX swap — least favorable of 3' },
  { year: 2029, round: 2, status: 'incoming', from: 'DAL' },
  { year: 2029, round: 2, status: 'incoming', from: 'GSW' },
  { year: 2029, round: 2, status: 'incoming', from: 'MEM' },
  { year: 2029, round: 2, status: 'own' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'incoming', from: 'DAL' },
  { year: 2030, round: 2, status: 'own' },
  { year: 2030, round: 2, status: 'incoming', from: 'BOS' },
  { year: 2030, round: 2, status: 'incoming', from: 'LAL' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 1, status: 'incoming', from: 'NYK' },
  { year: 2031, round: 2, status: 'incoming', from: 'LAL' },
  { year: 2031, round: 2, status: 'own' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 1, status: 'incoming', from: 'DEN' },
  { year: 2032, round: 2, status: 'incoming', from: 'MIA' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },

NYK: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 1, status: 'incoming', from: 'WAS', note: 'Protected 1-8' },
  { year: 2026, round: 2, status: 'own' },
  { year: 2026, round: 2, status: 'incoming', from: 'ORL/DET/MIL' },
  { year: 2027, round: 1, status: 'traded', to: 'BKN' },
  { year: 2027, round: 2, status: 'own' },
  { year: 2028, round: 1, status: 'own', note: 'BKN swap rights' },
  { year: 2028, round: 2, status: 'incoming', from: 'BOS', note: 'Protected 31-45' },
  { year: 2028, round: 2, status: 'incoming', from: 'IND/PHX' },
  { year: 2028, round: 2, status: 'traded', to: 'DET' },
  { year: 2029, round: 1, status: 'traded', to: 'BKN' },
  { year: 2029, round: 2, status: 'traded', to: 'DET/CHI' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'traded', to: 'ATL' },
  { year: 2031, round: 1, status: 'traded', to: 'BKN' },
  { year: 2031, round: 2, status: 'traded', to: 'CHA' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], stepien: true, tradeExceptions: [] },

PHI: { picks: [
  { year: 2026, round: 1, status: 'traded', to: 'OKC', note: 'Protected 1-4; rolls to 2027 (1-4)' },
  { year: 2026, round: 2, status: 'traded', to: 'OKC/PHX/WAS' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 2, status: 'own' },
  { year: 2027, round: 2, status: 'incoming', from: 'GSW/PHX' },
  { year: 2028, round: 1, status: 'incoming', from: 'LAC' },
  { year: 2028, round: 1, status: 'traded', to: 'BKN', note: 'Protected 1-8 (if PHI conveys 1st to OKC in 2026)' },
  { year: 2028, round: 2, status: 'own' },
  { year: 2028, round: 2, status: 'incoming', from: 'DET', note: 'Protected 31-55' },
  { year: 2028, round: 2, status: 'incoming', from: 'GSW' },
  { year: 2029, round: 1, status: 'own', note: 'LAC swap rights (prot 1-3)' },
  { year: 2029, round: 2, status: 'own' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'incoming', from: 'PHX/POR' },
  { year: 2030, round: 2, status: 'incoming', from: 'WAS' },
  { year: 2030, round: 2, status: 'traded', to: 'DAL' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },

TOR: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 2, status: 'incoming', from: 'LAL' },
  { year: 2026, round: 2, status: 'traded', to: 'IND', note: 'Protected 31-55' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 2, status: 'own' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'own' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 2, status: 'own' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'own' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'traded', to: 'NOP' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },

CHI: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 1, status: 'incoming', from: 'POR', note: 'Protected 1-14; rolls to 2027/2028' },
  { year: 2026, round: 2, status: 'traded', to: 'HOU' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 2, status: 'incoming', from: 'DEN' },
  { year: 2027, round: 2, status: 'traded', to: 'WAS' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'own' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 2, status: 'own' },
  { year: 2029, round: 2, status: 'incoming', from: 'DET/MIL/NYK' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'own' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },

CLE: { picks: [
  { year: 2026, round: 1, status: 'own', note: 'UTA/SAS/ATL/MIN swap pool' },
  { year: 2026, round: 2, status: 'own' },
  { year: 2027, round: 1, status: 'traded', to: 'UTA/PHX' },
  { year: 2027, round: 2, status: 'traded', to: 'MIN' },
  { year: 2028, round: 1, status: 'own', note: 'UTA swap rights' },
  { year: 2028, round: 2, status: 'own' },
  { year: 2029, round: 1, status: 'traded', to: 'UTA/CHA' },
  { year: 2029, round: 2, status: 'traded', to: 'ATL' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'traded', to: 'SAS' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'traded', to: 'UTA/BOS' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], stepien: true, tradeExceptions: [] },

DET: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 2, status: 'incoming', from: 'CHA', note: 'Protected 31-55' },
  { year: 2026, round: 2, status: 'traded', to: 'BOS/ORL/NYK' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 2, status: 'incoming', from: 'BKN/DAL' },
  { year: 2027, round: 2, status: 'own' },
  { year: 2027, round: 2, status: 'incoming', from: 'MIL' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'own', note: 'UTA swap rights' },
  { year: 2028, round: 2, status: 'incoming', from: 'CHA/LAC' },
  { year: 2028, round: 2, status: 'incoming', from: 'MIA' },
  { year: 2028, round: 2, status: 'incoming', from: 'NYK' },
  { year: 2028, round: 2, status: 'traded', to: 'PHI', note: 'Protected 31-55' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 2, status: 'own' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'incoming', from: 'MIN' },
  { year: 2030, round: 2, status: 'own' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'incoming', from: 'MIN/GSW', note: 'Less favorable' },
  { year: 2031, round: 2, status: 'incoming', from: 'DAL' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [{ amount: 14100000, expires: '2026-07', from: 'Tobias Harris space' }] },

IND: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 2, status: 'own', note: 'ATL/MEM/SAS/MIN swap scenario' },
  { year: 2026, round: 2, status: 'incoming', from: 'TOR', note: 'Protected 31-55' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 2, status: 'incoming', from: 'UTA' },
  { year: 2027, round: 2, status: 'traded', to: 'OKC/NYK/SAS/MIA' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'own', note: 'PHX swap rights' },
  { year: 2028, round: 2, status: 'incoming', from: 'DAL' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 2, status: 'own', note: 'WAS swap rights' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'own' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own', note: 'WAS/MEM swap — least favorable' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },

MIL: { picks: [
  { year: 2026, round: 1, status: 'own', note: 'ATL swap rights; ATL gets best of MIL/NOP' },
  { year: 2026, round: 2, status: 'incoming', from: 'UTA', note: 'Protected 31-55' },
  { year: 2026, round: 2, status: 'traded', to: 'BOS/ORL/NYK' },
  { year: 2027, round: 1, status: 'own', note: 'NOP swap rights' },
  { year: 2027, round: 2, status: 'traded', to: 'DET' },
  { year: 2028, round: 1, status: 'own', note: 'POR swap rights' },
  { year: 2028, round: 2, status: 'traded', to: 'OKC' },
  { year: 2029, round: 1, status: 'traded', to: 'POR/WAS' },
  { year: 2029, round: 2, status: 'traded', to: 'DET/CHI' },
  { year: 2030, round: 1, status: 'own', note: 'POR swap rights' },
  { year: 2030, round: 2, status: 'traded', to: 'ORL' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'traded', to: 'CHA' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'traded', to: 'CHA' },
], stepien: true, tradeExceptions: [] },

CHA: { picks: [
  { year: 2026, round: 1, status: 'own', note: 'PHX/WAS/ORL/MEM swap scenario' },
  { year: 2026, round: 2, status: 'incoming', from: 'DEN/GSW' },
  { year: 2026, round: 2, status: 'traded', to: 'SAC/DET' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 1, status: 'incoming', from: 'MIA', note: 'Protected 1-14' },
  { year: 2027, round: 1, status: 'incoming', from: 'DAL', note: 'Protected 1-2' },
  { year: 2027, round: 2, status: 'incoming', from: 'NOP/POR' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'own', note: 'LAC swap rights' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 1, status: 'incoming', from: 'UTA/CLE/MIN', note: 'Least favorable of pool' },
  { year: 2029, round: 2, status: 'incoming', from: 'DEN' },
  { year: 2029, round: 2, status: 'own' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'own' },
  { year: 2030, round: 2, status: 'incoming', from: 'LAC/UTA' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'incoming', from: 'NYK' },
  { year: 2031, round: 2, status: 'incoming', from: 'PHX' },
  { year: 2031, round: 2, status: 'own' },
  { year: 2031, round: 2, status: 'incoming', from: 'DEN' },
  { year: 2031, round: 2, status: 'incoming', from: 'MIL' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'incoming', from: 'MIL' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },

MIA: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 2, status: 'own', note: 'ATL/MEM/SAS/MIN swap scenario' },
  { year: 2026, round: 2, status: 'incoming', from: 'BKN', note: 'Protected 31-55' },
  { year: 2027, round: 1, status: 'traded', to: 'CHA', note: 'Protected 1-14' },
  { year: 2027, round: 2, status: 'own', note: 'OKC/NYK/SAS swap rights' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'traded', to: 'DET' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 2, status: 'traded', to: 'OKC' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'traded', to: 'OKC' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own', note: 'WAS/MEM swap rights' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'traded', to: 'BKN' },
], stepien: true, tradeExceptions: [{ amount: 16800000, expires: '2026-07', from: 'Caleb Martin trade' }] },

ORL: { picks: [
  { year: 2026, round: 1, status: 'own', note: 'WAS swap rights' },
  { year: 2026, round: 2, status: 'incoming', from: 'DET/MIL' },
  { year: 2026, round: 2, status: 'own' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 2, status: 'own' },
  { year: 2028, round: 1, status: 'traded', to: 'POR' },
  { year: 2028, round: 2, status: 'own' },
  { year: 2028, round: 2, status: 'incoming', from: 'LAL/WAS' },
  { year: 2029, round: 1, status: 'own', note: 'MEM swap rights (prot 1-2)' },
  { year: 2029, round: 2, status: 'own' },
  { year: 2030, round: 1, status: 'traded', to: 'MEM' },
  { year: 2030, round: 2, status: 'own', note: 'NOP swap rights' },
  { year: 2030, round: 2, status: 'incoming', from: 'MIL' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own', note: 'NOP swap rights' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },

WAS: { picks: [
  { year: 2026, round: 1, status: 'own', note: 'PHX swap rights' },
  { year: 2026, round: 1, status: 'traded', to: 'NYK', note: 'Protected 1-8' },
  { year: 2026, round: 1, status: 'incoming', from: 'OKC/HOU/LAC', note: 'Least favorable of OKC/HOU/LAC' },
  { year: 2026, round: 2, status: 'own' },
  { year: 2026, round: 2, status: 'incoming', from: 'MIN/NYK/NOP/POR' },
  { year: 2026, round: 2, status: 'incoming', from: 'PHX' },
  { year: 2026, round: 2, status: 'incoming', from: 'OKC/DAL/PHI' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 2, status: 'incoming', from: 'GSW/PHX' },
  { year: 2027, round: 2, status: 'incoming', from: 'CHI' },
  { year: 2027, round: 2, status: 'incoming', from: 'BKN/DAL' },
  { year: 2027, round: 2, status: 'own' },
  { year: 2028, round: 1, status: 'own', note: 'MIL/POR swap rights' },
  { year: 2028, round: 1, status: 'own', note: 'PHI/BKN/PHX swap rights' },
  { year: 2028, round: 2, status: 'incoming', from: 'DEN', note: 'Protected 31-33' },
  { year: 2028, round: 2, status: 'own' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 1, status: 'incoming', from: 'BOS/MIL/POR' },
  { year: 2029, round: 2, status: 'incoming', from: 'HOU' },
  { year: 2029, round: 2, status: 'incoming', from: 'LAL' },
  { year: 2029, round: 2, status: 'traded', to: 'IND/POR' },
  { year: 2030, round: 1, status: 'own', note: 'PHX/MEM swap rights' },
  { year: 2030, round: 2, status: 'incoming', from: 'PHX/POR' },
  { year: 2030, round: 2, status: 'traded', to: 'PHI' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own', note: 'IND/MIA/MEM swap rights' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
  { year: 2032, round: 2, status: 'incoming', from: 'UTA' },
], tradeExceptions: [{ amount: 13500000, expires: '2026-07', from: 'Kyle Kuzma trade' }] },

DEN: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 2, status: 'traded', to: 'CHA/MIN' },
  { year: 2027, round: 1, status: 'traded', to: 'OKC', note: 'Protected 1-5; rolls to 2028/2029' },
  { year: 2027, round: 2, status: 'traded', to: 'CHI' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'traded', to: 'WAS', note: 'Protected 31-33' },
  { year: 2029, round: 1, status: 'traded', to: 'OKC', note: '2nd potential 1st, prot 1-5' },
  { year: 2029, round: 2, status: 'traded', to: 'CHA' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'traded', to: 'OKC' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'traded', to: 'CHA' },
  { year: 2032, round: 1, status: 'traded', to: 'BKN' },
  { year: 2032, round: 2, status: 'own' },
], stepien: true, tradeExceptions: [] },

MIN: { picks: [
  { year: 2026, round: 1, status: 'own', note: 'SAS/UTA/CLE swap pool' },
  { year: 2026, round: 2, status: 'incoming', from: 'DEN/GSW' },
  { year: 2026, round: 2, status: 'incoming', from: 'IND/MIA/SAS', note: 'Least favorable of swap' },
  { year: 2026, round: 2, status: 'traded', to: 'BOS/NYK/WAS' },
  { year: 2027, round: 1, status: 'traded', to: 'UTA/PHX' },
  { year: 2027, round: 2, status: 'incoming', from: 'CLE' },
  { year: 2027, round: 2, status: 'traded', to: 'POR' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'traded', to: 'SAS' },
  { year: 2029, round: 1, status: 'traded', to: 'UTA/CHA', note: 'Protected 1-5' },
  { year: 2029, round: 2, status: 'own' },
  { year: 2030, round: 1, status: 'own', note: 'SAS/DAL swap (prot #1)' },
  { year: 2030, round: 2, status: 'incoming', from: 'MEM', note: 'Protected 31-50' },
  { year: 2030, round: 2, status: 'traded', to: 'DET' },
  { year: 2031, round: 1, status: 'traded', to: 'SAC' },
  { year: 2031, round: 2, status: 'own', note: 'GSW swap rights' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
  { year: 2032, round: 2, status: 'incoming', from: 'HOU/PHX' },
], stepien: true, tradeExceptions: [] },

OKC: { picks: [
  { year: 2026, round: 1, status: 'own', note: 'Gets 2 most favorable of own, HOU (prot 1-4), LAC' },
  { year: 2026, round: 1, status: 'incoming', from: 'PHI', note: 'Protected 1-4' },
  { year: 2026, round: 1, status: 'incoming', from: 'UTA', note: 'Protected 1-8' },
  { year: 2026, round: 2, status: 'own', note: 'Swap: most favorable of PHI/DAL/OKC 2nds' },
  { year: 2026, round: 2, status: 'incoming', from: 'PHI/DAL' },
  { year: 2027, round: 1, status: 'own', note: 'LAC swap rights' },
  { year: 2027, round: 1, status: 'incoming', from: 'DEN', note: 'Protected 1-5' },
  { year: 2027, round: 1, status: 'incoming', from: 'SAS', note: 'Protected 1-16' },
  { year: 2027, round: 2, status: 'own', note: 'HOU/IND/MIA swap rights' },
  { year: 2028, round: 1, status: 'own', note: 'DAL swap rights' },
  { year: 2028, round: 2, status: 'own' },
  { year: 2028, round: 2, status: 'incoming', from: 'MIL' },
  { year: 2028, round: 2, status: 'incoming', from: 'UTA' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 1, status: 'incoming', from: 'DEN', note: 'Protected 1-5' },
  { year: 2029, round: 2, status: 'incoming', from: 'BOS' },
  { year: 2029, round: 2, status: 'own' },
  { year: 2029, round: 2, status: 'incoming', from: 'ATL' },
  { year: 2029, round: 2, status: 'incoming', from: 'MIA' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'incoming', from: 'DEN' },
  { year: 2030, round: 2, status: 'incoming', from: 'HOU' },
  { year: 2030, round: 2, status: 'incoming', from: 'MIA' },
  { year: 2030, round: 2, status: 'own' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own', note: 'ORL/NOP swap — gets less favorable' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },

POR: { picks: [
  { year: 2026, round: 1, status: 'traded', to: 'CHI', note: 'Protected 1-14; rolls to 2027/2028' },
  { year: 2026, round: 2, status: 'incoming', from: 'MEM', note: 'Protected 31-42' },
  { year: 2026, round: 2, status: 'traded', to: 'BOS/SAS/WAS' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 2, status: 'own', note: 'HOU/CHA swap rights' },
  { year: 2027, round: 2, status: 'incoming', from: 'MIN' },
  { year: 2028, round: 1, status: 'own', note: 'MIL swap rights' },
  { year: 2028, round: 1, status: 'incoming', from: 'ORL' },
  { year: 2028, round: 2, status: 'own' },
  { year: 2028, round: 2, status: 'incoming', from: 'SAC' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 2, status: 'incoming', from: 'IND/WAS' },
  { year: 2029, round: 2, status: 'traded', to: 'MEM' },
  { year: 2030, round: 1, status: 'own', note: 'MIL swap rights' },
  { year: 2030, round: 2, status: 'traded', to: 'PHI/WAS' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },

UTA: { picks: [
  { year: 2026, round: 1, status: 'own', note: 'MIN/CLE swap — gets most favorable of own (prot 9-30), MIN, CLE' },
  { year: 2026, round: 1, status: 'traded', to: 'OKC', note: 'Protected 1-8' },
  { year: 2026, round: 2, status: 'traded', to: 'SAS/MIL' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 1, status: 'incoming', from: 'LAL', note: 'Protected 1-4' },
  { year: 2027, round: 2, status: 'incoming', from: 'LAC' },
  { year: 2027, round: 2, status: 'incoming', from: 'BOS/ORL' },
  { year: 2027, round: 2, status: 'traded', to: 'IND' },
  { year: 2028, round: 1, status: 'own', note: 'CLE swap rights' },
  { year: 2028, round: 2, status: 'own', note: 'Complex swap (DET/CHA/LAC/MIA/NYK)' },
  { year: 2028, round: 2, status: 'traded', to: 'OKC' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 2, status: 'own' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'own' },
  { year: 2031, round: 1, status: 'incoming', from: 'PHX' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'incoming', from: 'BOS/CLE' },
  { year: 2031, round: 2, status: 'own' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'traded', to: 'WAS' },
], tradeExceptions: [{ amount: 18400000, expires: '2026-07', from: 'Lauri Markkanen trade' }] },

GSW: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 2, status: 'traded', to: 'CHA/MIN' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 2, status: 'traded', to: 'PHI/WAS' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'traded', to: 'PHI' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 2, status: 'traded', to: 'BKN' },
  { year: 2030, round: 1, status: 'own', note: 'To WAS protected 1-20' },
  { year: 2030, round: 2, status: 'own' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own', note: 'MIN swap rights' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'traded', to: 'MEM', note: 'Protected 31-50' },
], tradeExceptions: [] },

LAC: { picks: [
  { year: 2026, round: 1, status: 'traded', to: 'OKC/WAS' },
  { year: 2026, round: 2, status: 'own', note: 'BKN swap rights' },
  { year: 2026, round: 2, status: 'incoming', from: 'MEM', note: 'Protected 31-42' },
  { year: 2027, round: 1, status: 'own', note: 'OKC swap rights' },
  { year: 2027, round: 2, status: 'traded', to: 'UTA' },
  { year: 2028, round: 1, status: 'traded', to: 'PHI' },
  { year: 2028, round: 2, status: 'traded', to: 'CHA/DET' },
  { year: 2029, round: 1, status: 'own', note: 'PHI swap rights (prot 1-3)' },
  { year: 2029, round: 2, status: 'traded', to: 'SAS' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'traded', to: 'CHA/UTA' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },

LAL: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 2, status: 'traded', to: 'TOR' },
  { year: 2027, round: 1, status: 'traded', to: 'UTA', note: 'Protected 1-4' },
  { year: 2027, round: 2, status: 'traded', to: 'BKN' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'traded', to: 'ORL/WAS' },
  { year: 2029, round: 1, status: 'traded', to: 'DAL' },
  { year: 2029, round: 2, status: 'traded', to: 'WAS' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'traded', to: 'BKN' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'traded', to: 'BKN' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], stepien: true, tradeExceptions: [] },

PHX: { picks: [
  { year: 2026, round: 1, status: 'own', note: 'WAS swap rights' },
  { year: 2026, round: 2, status: 'incoming', from: 'OKC/DAL/PHI' },
  { year: 2026, round: 2, status: 'traded', to: 'WAS' },
  { year: 2027, round: 1, status: 'incoming', from: 'UTA/CLE/MIN' },
  { year: 2027, round: 1, status: 'traded', to: 'HOU' },
  { year: 2027, round: 2, status: 'traded', to: 'PHI/WAS' },
  { year: 2028, round: 1, status: 'own', note: 'BKN/NYK/WAS swap rights' },
  { year: 2028, round: 2, status: 'traded', to: 'IND/NYK' },
  { year: 2029, round: 1, status: 'own', note: 'HOU swap rights' },
  { year: 2029, round: 2, status: 'own' },
  { year: 2030, round: 1, status: 'own', note: 'WAS/MEM swap rights' },
  { year: 2030, round: 2, status: 'traded', to: 'PHI/WAS' },
  { year: 2031, round: 1, status: 'traded', to: 'UTA' },
  { year: 2031, round: 2, status: 'traded', to: 'CHA' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own', note: 'MIN swap rights' },
], stepien: true, tradeExceptions: [] },

SAC: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 2, status: 'own' },
  { year: 2026, round: 2, status: 'incoming', from: 'CHA', note: 'Protected 56-60' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 1, status: 'incoming', from: 'SAS', note: 'Protected 17-30' },
  { year: 2027, round: 2, status: 'incoming', from: 'CHA' },
  { year: 2027, round: 2, status: 'own' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'traded', to: 'POR' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 2, status: 'traded', to: 'HOU' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'traded', to: 'SAS' },
  { year: 2031, round: 1, status: 'incoming', from: 'MIN' },
  { year: 2031, round: 1, status: 'own', note: 'SAS swap rights' },
  { year: 2031, round: 2, status: 'traded', to: 'SAS' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },

DAL: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 2, status: 'traded', to: 'OKC/PHX/WAS' },
  { year: 2027, round: 1, status: 'traded', to: 'CHA', note: 'Protected 1-2' },
  { year: 2027, round: 2, status: 'traded', to: 'WAS/DET' },
  { year: 2028, round: 1, status: 'own', note: 'OKC swap rights' },
  { year: 2028, round: 2, status: 'traded', to: 'IND' },
  { year: 2029, round: 1, status: 'own', note: 'HOU swap rights' },
  { year: 2029, round: 1, status: 'incoming', from: 'LAL' },
  { year: 2029, round: 2, status: 'traded', to: 'BKN' },
  { year: 2030, round: 1, status: 'own', note: 'SAS swap rights (prot #1)' },
  { year: 2030, round: 2, status: 'incoming', from: 'PHI' },
  { year: 2030, round: 2, status: 'traded', to: 'BKN' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'traded', to: 'DET' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },

HOU: { picks: [
  { year: 2026, round: 1, status: 'traded', to: 'OKC/WAS', note: 'Protected 1-4' },
  { year: 2026, round: 2, status: 'own', note: 'Sent to OKC if HOU 1st is protected' },
  { year: 2026, round: 2, status: 'incoming', from: 'CHI' },
  { year: 2027, round: 1, status: 'own', note: 'BKN swap rights' },
  { year: 2027, round: 1, status: 'incoming', from: 'PHX' },
  { year: 2027, round: 2, status: 'incoming', from: 'MEM' },
  { year: 2027, round: 2, status: 'incoming', from: 'POR/NOP', note: 'Less favorable if outside prot 31-55' },
  { year: 2027, round: 2, status: 'traded', to: 'OKC/NYK/SAS/MIA' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'own' },
  { year: 2029, round: 1, status: 'own', note: 'DAL/PHX swap — gets 2 best of own/DAL/PHX' },
  { year: 2029, round: 2, status: 'incoming', from: 'SAC' },
  { year: 2029, round: 2, status: 'traded', to: 'WAS' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'traded', to: 'OKC' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own', note: 'ATL swap rights (prot 56-60)' },
  { year: 2031, round: 2, status: 'traded', to: 'BOS', note: 'Protected 31-55' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'traded', to: 'MIN/PHX' },
], tradeExceptions: [] },

MEM: { picks: [
  { year: 2026, round: 1, status: 'own' },
  { year: 2026, round: 2, status: 'own', note: 'LAC swap — most favorable of BOS/IND/MIA/LAC' },
  { year: 2026, round: 2, status: 'traded', to: 'LAC/POR', note: 'LAC if 43-60; POR if 31-42' },
  { year: 2027, round: 1, status: 'own' },
  { year: 2027, round: 2, status: 'traded', to: 'HOU' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'traded', to: 'BKN' },
  { year: 2029, round: 1, status: 'own', note: 'ORL swap rights (prot 1-2)' },
  { year: 2029, round: 2, status: 'incoming', from: 'POR' },
  { year: 2029, round: 2, status: 'traded', to: 'BKN' },
  { year: 2030, round: 1, status: 'incoming', from: 'ORL' },
  { year: 2030, round: 1, status: 'own', note: 'WAS/PHX swap rights' },
  { year: 2030, round: 2, status: 'traded', to: 'MIN', note: 'Protected 31-50' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own', note: 'IND/MIA/WAS swap rights' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
  { year: 2032, round: 2, status: 'incoming', from: 'GSW', note: 'Protected 31-50' },
], tradeExceptions: [] },

NOP: { picks: [
  { year: 2026, round: 1, status: 'traded', to: 'ATL', note: 'ATL exercised swap rights (best of NOP/MIL)' },
  { year: 2026, round: 2, status: 'traded', to: 'BOS/SAS/WAS' },
  { year: 2027, round: 1, status: 'own', note: 'MIL swap rights' },
  { year: 2027, round: 2, status: 'traded', to: 'CHA/POR' },
  { year: 2028, round: 1, status: 'own' },
  { year: 2028, round: 2, status: 'traded', to: 'SAS' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 2, status: 'traded', to: 'SAS' },
  { year: 2030, round: 1, status: 'own' },
  { year: 2030, round: 2, status: 'own' },
  { year: 2031, round: 1, status: 'own' },
  { year: 2031, round: 2, status: 'own', note: 'ORL swap rights' },
  { year: 2031, round: 2, status: 'incoming', from: 'TOR' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [
  { amount: 13500000, expires: '2026-07', from: 'Zion Williamson trade' },
  { amount: 13000000, expires: '2026-07', from: 'CJ McCollum trade' },
] },

SAS: { picks: [
  { year: 2026, round: 1, status: 'own', note: 'Swap: gets most favorable of own and ATL' },
  { year: 2026, round: 2, status: 'own', note: 'IND/MIA swap rights' },
  { year: 2026, round: 2, status: 'incoming', from: 'NOP/POR' },
  { year: 2026, round: 2, status: 'incoming', from: 'UTA', note: 'Protected 56-60' },
  { year: 2027, round: 1, status: 'incoming', from: 'ATL' },
  { year: 2027, round: 1, status: 'traded', to: 'SAC/OKC', note: 'Own 1st to SAC prot 17-30 or OKC prot 1-16' },
  { year: 2027, round: 2, status: 'own', note: 'OKC/HOU/IND/MIA swap rights' },
  { year: 2028, round: 1, status: 'own', note: 'BOS swap rights (prot #1)' },
  { year: 2028, round: 2, status: 'incoming', from: 'NOP' },
  { year: 2028, round: 2, status: 'incoming', from: 'MIN' },
  { year: 2028, round: 2, status: 'own' },
  { year: 2029, round: 1, status: 'own' },
  { year: 2029, round: 2, status: 'incoming', from: 'LAC' },
  { year: 2029, round: 2, status: 'incoming', from: 'NOP' },
  { year: 2029, round: 2, status: 'own' },
  { year: 2030, round: 1, status: 'own', note: 'DAL/MIN swap (prot #1)' },
  { year: 2030, round: 2, status: 'incoming', from: 'SAC' },
  { year: 2030, round: 2, status: 'own' },
  { year: 2030, round: 2, status: 'incoming', from: 'CLE' },
  { year: 2031, round: 1, status: 'own', note: 'SAC swap rights' },
  { year: 2031, round: 2, status: 'own' },
  { year: 2031, round: 2, status: 'incoming', from: 'SAC' },
  { year: 2032, round: 1, status: 'own' },
  { year: 2032, round: 2, status: 'own' },
], tradeExceptions: [] },
};

// ============================================================================
// NO-TRADE CLAUSES
// ============================================================================
export const NO_TRADE_CLAUSES = {
  full: [
    { name: 'LeBron James', team: 'LAL', type: 'Full NTC' },
    { name: 'Damian Lillard', team: 'MIL', type: 'Full NTC' },
  ],
  veto: [
    { name: 'James Harden', team: 'LAC', type: 'Veto (1-yr re-sign)' },
  ],
};

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================
export function getTeamPicks(teamAbbr) {
  return DRAFT_PICKS[teamAbbr] || { picks: [], tradeExceptions: [] };
}
export function getPicksForYear(teamAbbr, year) {
  const team = DRAFT_PICKS[teamAbbr];
  if (!team) return [];
  return team.picks.filter(p => p.year === year && (p.status === 'own' || p.status === 'incoming'));
}
export function getTradedPicks(teamAbbr, year) {
  const team = DRAFT_PICKS[teamAbbr];
  if (!team) return [];
  return team.picks.filter(p => p.year === year && p.status === 'traded');
}
export function canTradePick(teamAbbr, year) {
  const team = DRAFT_PICKS[teamAbbr];
  if (!team) return true;
  const thisYear = team.picks.filter(p => p.year === year && p.round === 1 && p.status === 'traded');
  if (thisYear.length > 0) return false;
  const prevYear = team.picks.filter(p => p.year === year - 1 && p.round === 1 && p.status === 'traded');
  const nextYear = team.picks.filter(p => p.year === year + 1 && p.round === 1 && p.status === 'traded');
  if (prevYear.length > 0 || nextYear.length > 0) return false;
  return true;
}
export function hasNoTradeClause(playerName) {
  const fullNTC = NO_TRADE_CLAUSES.full.find(p => p.name === playerName);
  if (fullNTC) return fullNTC;
  const veto = NO_TRADE_CLAUSES.veto.find(p => p.name === playerName);
  if (veto) return veto;
  return null;
}
export function count2026Firsts(teamAbbr) {
  const team = DRAFT_PICKS[teamAbbr];
  if (!team) return 0;
  return team.picks.filter(p => p.year === 2026 && p.round === 1 && (p.status === 'own' || p.status === 'incoming')).length;
}
export default DRAFT_PICKS;
